import { render, staticRenderFns } from "./RegisterVue.vue?vue&type=template&id=6ecf5f0f&scoped=true"
import script from "./RegisterVue.vue?vue&type=script&lang=js"
export * from "./RegisterVue.vue?vue&type=script&lang=js"
import style0 from "./RegisterVue.vue?vue&type=style&index=0&id=6ecf5f0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecf5f0f",
  null
  
)

export default component.exports